import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Popconfirm } from 'antd';
import { useTranslation } from 'react-i18next';
import { DeleteOutlined, WarningOutlined } from '@ant-design/icons';
import { PageHeaderCustom } from '../../components';
import { useAuthContext } from '../../contexts/AuthContext';
import { useErrorMessage } from '../../utils/ErrorMessage';
import { SchemaContextProvider } from '../../schemaTool/SchemaContext';
import Schema from '../../schemaTool/Schema';

const ShowD12 = () => {
  const { id } = useParams();
  const { dispatchAPI, user } = useAuthContext();
  const { message } = useErrorMessage();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [d12Post, setD12Post] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [canEdit, setCanEdit] = useState(false);

  useEffect(async () => {
    try {
      const { data } = await dispatchAPI('GET', {
        url: `/d12/${id}`
      });
      setCanEdit(
        user.role === 'admins:SUPER-ADMIN' ||
          data?.contact === user._id ||
          data?.contact?._id === user._id
      );
    } catch (e) {
      message(e);
    }
  }, [user, id]);

  const getD12Post = useCallback(
    async (source, idProject) => {
      setIsLoading(true);
      try {
        const { data } = await dispatchAPI('GET', {
          url: `/${source}/${idProject || id}?populate=departData`
        });
        setD12Post(data);
      } catch (e) {
        message(e);
      }
      setIsLoading(false);
    },
    [id]
  );

  const deleteD12Post = async () => {
    try {
      await dispatchAPI('DELETE', { url: `/d12/${id}` });
      navigate(-1);
    } catch (e) {
      if (e.response) message(e.response.status);
    }
  };

  useEffect(() => {
    (async () => {
      await getD12Post('d12');
    })();
  }, [getD12Post]);

  return (
    <SchemaContextProvider sourcePost={d12Post} getSourcePost={getD12Post}>
      <PageHeaderCustom
        title={`${t('D12.show.title')}: ${d12Post?.name}`}
        extra={
          canEdit && (
            <Popconfirm
              title={t('datatable.column.action.delete.title')}
              okText={t('datatable.column.action.delete.ok')}
              okButtonProps={{ type: 'danger' }}
              cancelText={t('datatable.column.action.delete.cancel')}
              onConfirm={deleteD12Post}
              icon={<WarningOutlined />}
            >
              <Button type="link" danger>
                {`${t('buttons.delete')} `}
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          )
        }
      />
      <Schema id={id} origin="d12" isLoading={isLoading} />
    </SchemaContextProvider>
  );
};

export default ShowD12;
